const DISCREPANCY_0 = 'DISCREPANCY_0'
const DISCREPANCY_BETWEEN_1_10 = 'DISCREPANCY_BETWEEN_1_10'
const DISCREPANCY_BETWEEN_MINUS_1_10 = 'DISCREPANCY_BETWEEN_MINUS_1_10'
const DISCREPANCY_BEYOND_10 = 'DISCREPANCY_BEYOND_10'
const DISCREPANCY_BEYOND_MINUS_10 = 'DISCREPANCY_BEYOND_MINUS_10'

export default {
  options: {
    DISCREPANCY_0: {
      class: 'discrepancy-0',
      comparator: (value) => value >= -1 && value < 1,
      operator: 'custom',
      parameters: [
        {
          operator: 'gte',
          text: '-1%',
          value: -1,
        },
        {
          operator: 'lte',
          text: '1%',
          value: 1,
        },
      ],
      text: '0 %',
      value: DISCREPANCY_0,
    },
    DISCREPANCY_BETWEEN_1_10: {
      class: 'discrepancy-between-1-10',
      comparator: (value) => value >= 1 && value <= 10,
      operator: 'custom',
      parameters: [
        {
          operator: 'gte',
          text: '1%',
          value: 1,
        },
        {
          operator: 'lte',
          text: '10%',
          value: 10,
        },
      ],
      text: 'RANGE 1 to 10 %',
      value: DISCREPANCY_BETWEEN_1_10,
    },
    DISCREPANCY_BETWEEN_MINUS_1_10: {
      class: 'discrepancy-between-minus-1-10',
      comparator: (value) => value >= -10 && value <= -1,
      operator: 'custom',
      parameters: [
        {
          operator: 'gte',
          text: '-10%',
          value: -10,
        },
        {
          operator: 'lte',
          text: '-1%',
          value: -1,
        },
      ],
      text: 'RANGE -1 to -10 %',
      value: DISCREPANCY_BETWEEN_MINUS_1_10,
    },
    DISCREPANCY_BEYOND_10: {
      class: 'discrepancy-beyond-10',
      comparator: (value) => value >= 10,
      operator: 'custom',
      parameters: [
        {
          operator: 'gte',
          text: '10%',
          value: 10,
        },
      ],
      text: 'GREATER THAN 10 %',
      value: DISCREPANCY_BEYOND_10,
    },
    DISCREPANCY_BEYOND_MINUS_10: {
      class: 'discrepancy-beyond-minus-10',
      comparator: (value) => value <= -10,
      operator: 'custom',
      parameters: [
        {
          operator: 'lte',
          text: '-10%',
          value: -10,
        },
      ],
      text: 'LESS THAN -10 %',
      value: DISCREPANCY_BEYOND_MINUS_10,
    },
  },

  isDiscrepancyInRange(discrepancyValue, discrepancyOption) {
    const { options } = this
    const option = Object.keys(options).find((optionName) => {
      const { operator, value } = options[optionName]
      const { operator: optionOperator } = discrepancyOption

      return [operator, value].includes(optionOperator)
    })

    return option.comparator(discrepancyValue)
  },

  /**
   * Gets the classes needed to style Discrepancy Percentage values.
   * @param {number} discrepancyValue The result of (firstPartyImpressions - thirdPartyImpressions) / thirdPartyImpressions
   * @return {string} Classes needed to style Discrepancy Percentage values, i.e. 'discrepancy ${colorClass}'
   */
  getDiscrepancyClassName(discrepancyValue) {
    const { options } = this
    const discrepancyPercentage = discrepancyValue * 100

    const isDiscrepancyNaN = () => Number.isNaN(discrepancyPercentage) && 'value-invalid'
    const isDiscrepancyZero = () => options.DISCREPANCY_0.comparator(discrepancyPercentage) && 'discrepancy-0'
    const isDiscrepancyBetween1And10 = () => options.DISCREPANCY_BETWEEN_1_10.comparator(discrepancyPercentage) && 'discrepancy-between-1-10'
    const isDiscrepancyBetweenNegative1AndNegative10 = () => options.DISCREPANCY_BETWEEN_MINUS_1_10.comparator(discrepancyPercentage) && 'discrepancy-between-minus-1-10'
    const isDiscrepancyGreaterThan10 = () => options.DISCREPANCY_BEYOND_10.comparator(discrepancyPercentage) && 'discrepancy-beyond-10'
    const isDiscrepancyLessThanNegative10 = () => options.DISCREPANCY_BEYOND_MINUS_10.comparator(discrepancyPercentage) && 'discrepancy-beyond-minus-10'

    const valueBasedClassName = isDiscrepancyNaN()
      || isDiscrepancyZero()
      || isDiscrepancyBetween1And10()
      || isDiscrepancyBetweenNegative1AndNegative10()
      || isDiscrepancyGreaterThan10()
      || isDiscrepancyLessThanNegative10()

    return `discrepancy ${valueBasedClassName}`
  },
}
